<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户提现.审核状态')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户提现.审核状态')" v-model="queryParam.status" allowClear>
                  <a-select-option  :value="0">{{$t('用户提现.未审核')}}</a-select-option>
                  <a-select-option  :value="1">{{$t('用户提现.审核未通过')}}</a-select-option>
                  <a-select-option  :value="2">{{$t('用户提现.审核已通过')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>


            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['withdraw:withdraw:add']">-->
<!--          <a-icon type="plus" />{{$t('通用.按钮.新增')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['withdraw:withdraw:edit']">-->
<!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['withdraw:withdraw:remove']">-->
<!--          <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['withdraw:withdraw:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >


        <span slot="slotstatus" slot-scope="text, record">

           <span v-if="record.status == '0'">
             {{$t('用户提现.未审核')}}
           </span>
           <span v-if="record.status == '1'">
             {{$t('用户提现.审核未通过')}}
           </span>
           <span v-if="record.status == '2'">
             {{$t('用户提现.审核已通过')}}
           </span>
        </span>

        <span slot="slotwithdrawType" slot-scope="text, record">
           <span v-if="record.withdrawType == '1'">
             {{$t('用户提现.支付宝')}}
           </span>
           <span v-if="record.withdrawType == '2'">
             {{$t('用户提现.微信')}}
           </span>
           <span v-if="record.withdrawType == '3'">
             {{$t('用户提现.银行卡')}}
           </span>
        </span>


        <span slot="slotwithdrawUserType" slot-scope="text, record">
           <span v-if="record.withdrawUserType == '1'">
             {{$t('用户提现.普通用户提现')}}
           </span>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['withdraw:withdraw:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.status == '0'" v-hasPermi="['withdraw:withdraw:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.审核')}}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['withdraw:withdraw:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['withdraw:withdraw:remove']">-->
<!--            <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageWithdraw,listWithdraw, delWithdraw } from '@/api/withdraw/withdraw'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Withdraw',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: undefined,
        shopId: undefined,
        money: undefined,
        status: undefined,
        accountNum: undefined,
        accountName: undefined,
        serviceChargeNum: undefined,
        withdrawType: undefined,
        withdrawUserType: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        qrCode: undefined,
        name: undefined,
        cardholderName: undefined,
        bankName: undefined,
        cardNumber: undefined,
        openBank: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('用户提现.主键id'),
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('用户提现.用户ID'),
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('用户提现.店铺ID'),
        //   dataIndex: 'shopId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('用户提现.提现金额'),
          dataIndex: 'money',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户提现.提现手续费'),
          dataIndex: 'serviceChargeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户提现.到账金额'),
          dataIndex: 'daozhangMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户提现.审核状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'slotstatus'},
        },

        // {
        //   title: this.$t('用户提现.提现账号'),
        //   dataIndex: 'accountNum',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.提现账号姓名'),
        //   dataIndex: 'accountName',
        //   ellipsis: true,
        //   align: 'center'
        // },

        {
          title: this.$t('用户提现.提现方式'),
          dataIndex: 'withdrawType',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'slotwithdrawType'},
        },
        {
          title: this.$t('用户提现.账户类型'),
          dataIndex: 'withdrawUserType',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'slotwithdrawUserType'},
        },
        // {
        //   title: this.$t('用户提现.第三方订单号(微信或支付的交易单号)'),
        //   dataIndex: 'orderNo',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.失败原因'),
        //   dataIndex: 'failureReason',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.审核意见'),
        //   dataIndex: 'auditOpinion',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('用户提现.创建时间'),
          dataIndex: 'createTime',
          width:150,
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('用户提现.备注'),
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.提现二维码'),
        //   dataIndex: 'qrCode',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.姓名'),
        //   dataIndex: 'name',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.持卡人姓名'),
        //   dataIndex: 'cardholderName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.银行名称'),
        //   dataIndex: 'bankName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.卡号'),
        //   dataIndex: 'cardNumber',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户提现.开户行'),
        //   dataIndex: 'openBank',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询用户提现列表 */
    getList () {
      this.loading = true
     pageWithdraw(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        shopId: undefined,
        money: undefined,
        status: undefined,
        accountNum: undefined,
        accountName: undefined,
        serviceChargeNum: undefined,
        withdrawType: undefined,
        withdrawUserType: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        qrCode: undefined,
        name: undefined,
        cardholderName: undefined,
        bankName: undefined,
        cardNumber: undefined,
        openBank: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delWithdraw(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('withdraw/withdraw/export',
            ...that.queryParam
          , `用户提现_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
